import { render } from "./FAQBackNo.vue?vue&type=template&id=53e2f302&scoped=true&ts=true"
import script from "./FAQBackNo.vue?vue&type=script&setup=true&lang=ts"
export * from "./FAQBackNo.vue?vue&type=script&setup=true&lang=ts"

import "./FAQBackNo.vue?vue&type=style&index=0&id=53e2f302&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3807180263/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53e2f302"],['__file',"src/components/scan/newsinfo/FAQBackNo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "53e2f302"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('53e2f302', __exports__)) {
    console.log('reload')
    api.reload('53e2f302', __exports__)
  }
  
  module.hot.accept("./FAQBackNo.vue?vue&type=template&id=53e2f302&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('53e2f302', render)
  })

}


export default __exports__